module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-W.b9050534.png";